<div class="loop-detail-modal">
  <div class="loop-modal-title">
    <div class="title mx-auto col-12" id="modal-basic-title">
      {{ 'production-by-extraction-point' | lang }} {{ streetLabelModalTitle }} {{ streetName }}
    </div>
    <img appImageSelector alt="mt-image" imageType="icon" imageKey="close-gray" class="close-modal" (click)="activeModal.dismiss()">
    <div class="col-12 text-center modal-subtitle">
      {{ modalSubtitle }} - {{ date | inputDateFormat }}
    </div>
  </div>

  <div class="mat-tabs">
    <mat-tab-group (selectedTabChange)="changeTab($event)">
      <mat-tab [label]="'chart' | lang">
        <app-prod-by-typetruck-chart [zoneName]="zoneName" [streetName]="streetName" [shiftLabel]="shiftLabel"
          [loopByTypeTruck]="modalDataTypeTruck"></app-prod-by-typetruck-chart>
      </mat-tab>

      <mat-tab [label]="'statistics' | lang">
        <app-main-table class="point-typetruck-table" [tableConfig]="tableConfig"></app-main-table>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>